function convertDecimal(value) {
  if (value === null || value === '') {
    return value;
  }
  let rawValue = value;
  const decimalsRegex = /\.([0-9]{1,2})/;
  const result = decimalsRegex.exec(rawValue);
  // In case there is only one decimal
  if (result && result[1].length < 2) {
    rawValue += '0';
  } else if (!result) {
    // in case user didn't input a decimal then add decimal also
    if (rawValue.indexOf('.') === -1) rawValue += '.00';
    // else add decimal places
    else rawValue += '00';
  }
  return rawValue;
}

export default convertDecimal;



// WEBPACK FOOTER //
// ./src/helpers/convertDecimal.js